const STORAGE_KEY = 'encye-auth-session';
export const AUTH_EXPIRED_EVENT = 'encye-auth-expired';

export const getStoredSession = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
};

export const setStoredSession = (session) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
};

export const clearStoredSession = () => {
  localStorage.removeItem(STORAGE_KEY);
};

export const expireStoredSession = () => {
  clearStoredSession();
  window.dispatchEvent(new CustomEvent(AUTH_EXPIRED_EVENT, {
    detail: { message: 'Please login again' },
  }));
};

export const getToken = () => getStoredSession()?.token || '';

export const getUser = () => getStoredSession()?.user || null;

export const isAuthenticated = () => Boolean(getToken());

export const hasPermission = (permissionName) => Boolean(getUser()?.permissions?.[permissionName]);
